exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".links[data-v-622395dc]{display:flex;flex-wrap:wrap}.action-card[data-v-622395dc]{margin:20px 0;align-self:flex-start}.file-limit-reached[data-v-622395dc]{padding:0 5px;color:#ccc}", ""]);

// exports
